<script setup>
import ListingCard from '@components/ListingCard.vue'
import {ref, computed} from 'vue'

const props = defineProps({
  listings: {
    type: Array,
    required: true,
  },
})
</script>
<template>
  <div class="collection__line">
    <h2 class="collection__line-title">{{ listings[0].product_line?.title }}</h2>
    <p class="collection__line-excerpt">{{ listings[0].product_line?.description }}</p>
    <div class="collection__line-products">
      <ListingCard class="collection__listing" :listing="listing" v-for="listing in listings" :key="listing.id" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.collection__line {
  .collection__line-title {
    color: var(--primary-600, #183D4F);
    font-size: 28px;
    font-weight: 700;
    line-height: 40px; /* 142.857% */
    margin: 0;

    @media screen and (min-width: 768px) {
      text-align: center;
      font-size: 40px;
      line-height: 48px;
    }
  }
  .collection__line-excerpt {
    color: var(--neutral-1000, #3C3833);
    font-size: 16px;
    font-weight: 500;
    line-height: 28px; /* 175% */
    margin: 8px 0 0 0;

    @media screen and (min-width: 768px) {
      text-align: center;
      font-size: 18px;
      line-height: 32px;
    }
  }
  .collection__line-products {
    margin-top: 24px;
    border-top: 1px solid #C4C3C1;
    padding-top: 24px;
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 16px;

    @media screen and (min-width: 1068px) {
      grid-template-columns: repeat(4, minmax(0, 1fr));
      gap: 32px;
    }
  }
}
</style>
